module.exports = __webpack_public_path__ + "img/inst.b5ccb228.png";